module.exports = __webpack_public_path__ + "img/icon_arrow-karet.1021bbcc.svg";